import { useSetRecoilState, useRecoilState, useRecoilValue } from 'recoil';
import LicenseService from '../services/LicenseService/LicenseService';
import UserService from '../services/UserService/UserService';
import authService from '../services/AuthService/AuthService';
import SettingsService from '../services/SettingsService/SettingsService';
import BrowserStorage from '../services/StorageService/BrowserStorageService';
import { BASE_ORIGIN } from '../services/config';

import DisplayMessage from "../components/DisplayMessage/DisplayMessage";
import {
    alertState,
    activeUser,
    triggerConf,
    fieldPreviewData,
    personalizationState,
    licensePermission,
    rolePermission,
    unreadNotificationCount,
    automList,
    debugList,
    queueLog,
    activeSideBarMenu,
    triggerSelection,
    testAppLog,
    oauthState,
    schedulerNexRunTimes,
    browserTabId, saveAvailable, changedFields, initialActions, baseOrigin, operationLogsStatus
} from './recoil-state';
import { useTranslation } from 'react-i18next';
import ReactDOM from "react-dom";
import { useNavigate } from 'react-router-dom';
import convertHrtime from 'convert-hrtime';
import { useEffect, useRef } from 'react';

export { useRecoilActions };
let wss = {};
let intervalWS;

const envType = process.env.REACT_APP_ENV_TYPE;

function useRecoilActions() {
    const { t } = useTranslation();
    const setUser = useSetRecoilState(activeUser);
    const setAlert = useSetRecoilState(alertState);
    const setPersonalization = useSetRecoilState(personalizationState);
    const setRolePermission = useSetRecoilState(rolePermission);
    const setLicensePermission = useSetRecoilState(licensePermission);
    const setCount = useSetRecoilState(unreadNotificationCount);
    const setAutoms = useSetRecoilState(automList);
    const setDebugs = useSetRecoilState(debugList);
    const setQueueActivityLog = useSetRecoilState(queueLog);
    const setTestAppLog = useSetRecoilState(testAppLog);
    const setOAuthState = useSetRecoilState(oauthState);
    const setOperationLogsStatus = useSetRecoilState(operationLogsStatus);
    const setSchedulerNexRunTimes = useSetRecoilState(schedulerNexRunTimes);
    const setBaseOrigin = useSetRecoilState(baseOrigin);
    const connWs = useRef(null);

    const [tabId, setTabId] = useRecoilState(browserTabId);

    let history = useNavigate();

    useEffect(() => {

        // Sağlık kontrolü için bağlantı durumu düzenli aralıklarla kontrol edilir
        const intervalId = setInterval(() => {
            if (connWs.current && connWs.current.readyState !== WebSocket.OPEN) {
                console.log("Connection lost. Trying to connect again...");
                connection(); // Yeniden bağlanmayı başlat
            }
        }, 60000);
    }, []);


    return {
        login,
        getPersonalization,
        getLicensePermission,
        getRolePermission,
        logout,
        connection,
        disconnection,
        triggerConf,
        fieldPreviewData,
        activeSideBarMenu,
        triggerSelection,
        saveAvailable,
        changedFields,
        initialActions,
        setBaseOriginForImage
    }

    async function login(data, to) {
        const response = await authService.login(data);
        if (!response) {
            BrowserStorage.removeItem('authToken');
            BrowserStorage.removeItem('refreshToken');
            BrowserStorage.removeItem('userName');
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        } else {
            if (response.status) {
                BrowserStorage.setItem('authToken', response.payload.token);
                BrowserStorage.setItem('refreshToken', response.payload.refreshToken);
                BrowserStorage.setItem('userName', response.payload.user_name);
                setUser(response.payload.user_name);
                await getPersonalization();
                await getLicensePermission();
                await getRolePermission()
                history(to ? to : '/my-environment/automs');
            } else setAlert(alert => ({
                ...alert,
                show: true,
                message: t('MESSAGES.AUTH-PAGES.LOGIN-PAGE.' + response.message),
                severity: 'error'
            }))
        }
    }

    async function getPersonalization() {
        const response = await SettingsService.getPersonallization();
        if (response?.status) {
            setPersonalization(response.data);
        }
    }

    async function getLicensePermission() {
        const response = await LicenseService.getLicenseDetail();
        if (response && response.status && response.status !== 'fail') {
            setLicensePermission(response);
        }// else {
        //     setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        // }
    }

    async function getRolePermission() {
        const response = await UserService.getRolePermission();
        if (response && response.status && response.status !== 'fail') {
            setRolePermission(response);
        }
        // else {
        //     return { status: false, message: 'LOG-OUT' }
        // }
    }

    function logout() {
        BrowserStorage.removeItem('authToken');
        BrowserStorage.removeItem('refreshToken');
        BrowserStorage.removeItem('userName');
        setUser('');
        history('/login');
    }

    // function connection() {
    //     const ta = getTabId();
    //     if (wss[ta]) {
    //         return;
    //     }
    //     // disconnection(ta); //

    //     console.log("ENVS", process.env)
    //     console.log("ENVS UPDATED!", process.env)
    //     const token = JSON.parse(localStorage.getItem('refreshToken'));
    //     // const hostName = "betaautommate.com";
    //     const hostName = window.location.hostname;
    //     const connWs = envType ? new WebSocket(`wss://${hostName}/socket/tab_id=${ta}/token=${token}`)
    //         : new WebSocket(`wss://${hostName}:2087/tab_id=${ta}/token=${token}`)
    //     connWs.onopen = () => {
    //         // TODO bağlanma tarihi ile ilgili değerlendirme yapılacak.
    //         console.log("WSS Connection Provided!")
    //         intervalWS && clearInterval(intervalWS)
    //     };

    //     connWs.onmessage = (e) => {
    //         if (!wss[ta]) {
    //             return;
    //         }
    //         const jsonObj = JSON.parse(e.data);
    //         switch (jsonObj.message) {
    //             case 'NOTIFICATION_COUNT':
    //                 setCount(jsonObj.data.count === 0 ? undefined : jsonObj.data.count);
    //                 break;
    //             case 'NEW_NOTIFICATION':
    //                 setCount(count => count ? Number(count) + 1 : 1)
    //                 break;
    //             case 'SCHEDULER-WORKING-HOURS-UPDATE':
    //                 setSchedulerNexRunTimes(jsonObj.data);
    //                 break;
    //             case 'AUTOMS_QUEUE_INSERT_MESSAGE':
    //                 setAutoms(jsonObj.data.automQueue);
    //                 break;
    //             case 'IPAAS_QUEUE_INSERT_MESSAGE':
    //                 break;
    //             case 'AUTOMS_QUEUE_UPDATE_MESSAGE':
    //                 setAutoms(jsonObj.data.automQueue);
    //                 break;
    //             case 'IPAAS_QUEUE_UPDATE_MESSAGE':
    //                 break;
    //             case 'DISPLAY_MESSAGE':
    //                 let random = crypto.getRandomValues(new Uint32Array(1));
    //                 let newDiv = document.createElement("div");
    //                 newDiv.id = random;
    //                 document.body.appendChild(newDiv);
    //                 let target = document.getElementById(random);
    //                 if (target) {
    //                     ReactDOM.render(<DisplayMessage message={jsonObj.data.message} title={jsonObj.data.title}
    //                         random={crypto.getRandomValues(new Uint32Array(1))} />, target);
    //                 }
    //                 break;
    //             case 'NEW_LOG':
    //                 setQueueActivityLog(queue => !queue);
    //                 break;
    //             case 'DEBUGGING':
    //                 if (jsonObj.data.Value === 'STARTED') {
    //                     setDebugs(
    //                         (currentState) => [
    //                             ...currentState,
    //                             {
    //                                 header: jsonObj.data?.LibraryName + ' ' + jsonObj.data?.ActionName,
    //                                 time: 0,
    //                                 items: [jsonObj.data],
    //                                 id: jsonObj.data?.Id,
    //                                 parentId: jsonObj.data?.ParentId,
    //                                 itemId: jsonObj.itemId
    //                             },
    //                         ]);
    //                 } else {
    //                     setDebugs(
    //                         (currentState) => {
    //                             let state = JSON.parse(JSON.stringify(currentState));
    //                             const i = state.findIndex((x) => x.id === jsonObj.data?.Id);
    //                             if (i === -1) {
    //                                 return state;
    //                             }
    //                             const index = state[i].items.length - 1;
    //                             const time = convertHrtime(jsonObj.data.DebugTimeStamp - state[i].items[index].DebugTimeStamp);
    //                             const alltime = convertHrtime(jsonObj.data.DebugTimeStamp - state[i].items[0].DebugTimeStamp);
    //                             const t = Math.floor(time.seconds) + 's ' + Math.floor(time.milliseconds - (Math.floor(time.seconds) * 1000)) + 'ms';
    //                             if (currentState.length > 0 && currentState[currentState.length - 1].items[0].ActionName != jsonObj.data.ActionName) {

    //                                 state.push({
    //                                     header: jsonObj.data?.LibraryName + ' ' + jsonObj.data?.ActionName,
    //                                     time: t,
    //                                     items: [jsonObj.data],
    //                                     itemId: jsonObj.itemId
    //                                 })
    //                                 return state;
    //                             } else {
    //                                 // let i = state.length - 1;
    //                                 // let index = state[i].children.length - 1;
    //                                 // let time = convertHrtime(jsonObj.data.DataMessage.DebugTimeStamp - state[i].children[index].DataMessage.DebugTimeStamp);
    //                                 // let alltime = convertHrtime(jsonObj.data.DataMessage.DebugTimeStamp - state[i].children[0].DataMessage.DebugTimeStamp);
    //                                 jsonObj.data.time = t;
    //                                 state[i].time = Math.floor(alltime.seconds) + 's ' + Math.floor(alltime.milliseconds - (Math.floor(alltime.seconds) * 1000)) + 'ms';
    //                                 state[i].items.push(jsonObj.data);
    //                                 return state;
    //                             }

    //                         });
    //                 }
    //                 break;
    //             case 'TEST_APP_LOG':
    //                 setTestAppLog(
    //                     (currentState) => ({
    //                         ...currentState,
    //                         data: jsonObj.data,
    //                         triggerTime: new Date()
    //                     }));
    //                 break;
    //             case 'OAUTH-MESSAGE':
    //                 const severity = jsonObj.status ? "success" : "error"
    //                 let message = jsonObj.display_message;
    //                 if (message.includes("SYSTEM MESSAGE:")) {
    //                     message = message.split('SYSTEM MESSAGE:')[1].trim();
    //                 } else {
    //                     message = t("MESSAGES.CREDENTIAL." + jsonObj.display_message)
    //                 }
    //                 setAlert(alert => ({
    //                     ...alert,
    //                     show: true,
    //                     message,
    //                     severity
    //                 }))
    //                 setOAuthState(new Date());
    //                 break;

    //             case 'OPERATION-LOGS-STATUS-CHANGE':
    //                 setOperationLogsStatus({ operation_id: jsonObj.operation_id, status: jsonObj.status });
    //                 // recoil.
    //                 break;
    //             default:
    //                 break;
    //         }
    //     };

    //     connWs.onerror = (e) => {
    //         console.error("WebSocket Error: ", e);
    //         if (wss[ta]) {
    //             delete wss[ta];
    //         }
    //     };

    //     connWs.onclose = (e) => {
    //         console.log("WebSocket closed. Code:", e.code, "Reason:", e.reason);
    //         if (wss[ta]) {
    //             delete wss[ta];
    //         }

    //         if (!intervalWS) {
    //             intervalWS = setInterval(function () {
    //                 connection();
    //             }, 5000);
    //         }
    //     };

    //     wss[ta] = connWs;
    // }

    function connection() {
        const ta = getTabId();
        if (wss[ta]) {
            return;
        }

        const token = JSON.parse(localStorage.getItem("refreshToken"));
        const hostName = window.location.hostname;
        const envType = process.env.REACT_APP_ENV_TYPE;

        connWs.current = envType
            ? new WebSocket(`wss://${hostName}/socket/tab_id=${ta}/token=${token}`)
            : new WebSocket(`wss://${hostName}:2087/tab_id=${ta}/token=${token}`);

        connWs.current.onopen = () => {
            console.log("WSS Connection Provided!");
            intervalWS && clearInterval(intervalWS);
        };

        connWs.current.onmessage = (e) => {
            if (!wss[ta]) {
                return;
            }
            const jsonObj = JSON.parse(e.data);

            switch (jsonObj.message) {
                case 'NOTIFICATION_COUNT':
                    setCount(jsonObj.data.count === 0 ? undefined : jsonObj.data.count);
                    break;
                case 'NEW_NOTIFICATION':
                    setCount(count => count ? Number(count) + 1 : 1);
                    break;
                case 'SCHEDULER-WORKING-HOURS-UPDATE':
                    setSchedulerNexRunTimes(jsonObj.data);
                    break;
                case 'AUTOMS_QUEUE_INSERT_MESSAGE':
                    setAutoms(jsonObj.data.automQueue);
                    break;
                case 'AUTOMS_QUEUE_UPDATE_MESSAGE':
                    setAutoms(jsonObj.data.automQueue);
                    break;
                case 'DISPLAY_MESSAGE':
                    const random = crypto.getRandomValues(new Uint32Array(1));
                    const newDiv = document.createElement("div");
                    newDiv.id = random;
                    document.body.appendChild(newDiv);
                    const target = document.getElementById(random);
                    if (target) {
                        ReactDOM.render(
                            <DisplayMessage
                                message={jsonObj.data.message}
                                title={jsonObj.data.title}
                                random={crypto.getRandomValues(new Uint32Array(1))}
                            />,
                            target
                        );
                    }
                    break;
                case 'NEW_LOG':
                    setQueueActivityLog(queue => !queue);
                    break;
                case 'DEBUGGING':
                    if (jsonObj.data.Value === 'STARTED') {
                        setDebugs((currentState) => [
                            ...currentState,
                            {
                                header: jsonObj.data?.LibraryName + ' ' + jsonObj.data?.ActionName,
                                time: 0,
                                items: [jsonObj.data],
                                id: jsonObj.data?.Id,
                                parentId: jsonObj.data?.ParentId,
                                itemId: jsonObj.itemId
                            },
                        ]);
                    } else {
                        setDebugs((currentState) => {
                            const state = JSON.parse(JSON.stringify(currentState));
                            const i = state.findIndex((x) => x.id === jsonObj.data?.Id);
                            if (i === -1) return state;

                            const index = state[i].items.length - 1;
                            const time = convertHrtime(jsonObj.data.DebugTimeStamp - state[i].items[index].DebugTimeStamp);
                            const alltime = convertHrtime(jsonObj.data.DebugTimeStamp - state[i].items[0].DebugTimeStamp);
                            const t = Math.floor(time.seconds) + 's ' + Math.floor(time.milliseconds - (Math.floor(time.seconds) * 1000)) + 'ms';

                            if (currentState.length > 0 && currentState[currentState.length - 1].items[0].ActionName !== jsonObj.data.ActionName) {
                                state.push({
                                    header: jsonObj.data?.LibraryName + ' ' + jsonObj.data?.ActionName,
                                    time: t,
                                    items: [jsonObj.data],
                                    itemId: jsonObj.itemId
                                });
                                return state;
                            } else {
                                jsonObj.data.time = t;
                                state[i].time = Math.floor(alltime.seconds) + 's ' + Math.floor(alltime.milliseconds - (Math.floor(alltime.seconds) * 1000)) + 'ms';
                                state[i].items.push(jsonObj.data);
                                return state;
                            }
                        });
                    }
                    break;
                case 'TEST_APP_LOG':
                    setTestAppLog(currentState => ({
                        ...currentState,
                        data: jsonObj.data,
                        triggerTime: new Date()
                    }));
                    break;
                case 'OAUTH-MESSAGE':
                    const severity = jsonObj.status ? "success" : "error";
                    let message = jsonObj.display_message;
                    if (message.includes("SYSTEM MESSAGE:")) {
                        message = message.split("SYSTEM MESSAGE:")[1].trim();
                    } else {
                        message = t("MESSAGES.CREDENTIAL." + jsonObj.display_message);
                    }
                    setAlert(alert => ({
                        ...alert,
                        show: true,
                        message,
                        severity
                    }));
                    setOAuthState(new Date());
                    break;
                case 'OPERATION-LOGS-STATUS-CHANGE':
                    setOperationLogsStatus({ operation_id: jsonObj.operation_id, status: jsonObj.status });
                    break;
                default:
                    break;
            }
        };

        connWs.current.onerror = (e) => {
            console.error("WebSocket Error: ", e);
            if (wss[ta]) {
                delete wss[ta];
            }
        };

        connWs.current.onclose = (e) => {
            console.log("WebSocket closed. Code:", e.code, "Reason:", e.reason);
            if (wss[ta]) {
                delete wss[ta];
            }

            if (!intervalWS) {
                intervalWS = setInterval(() => {
                    connection();
                }, 5000);
            }
        };

        wss[ta] = connWs.current;
    }

    function generateTabId() {
        return Math.random().toString(36).substr(2, 8); // Generate a random 8-character string
    }

    function getTabId() {
        let tab_id;
        if (!tabId) {
            tab_id = generateTabId();
            setTabId(tab_id);
        } else {
            tab_id = tabId;
        }
        return tab_id;
    }

    // function disconnection() {
    //     if (ws) {
    //         ws.close();
    //     }
    // }
    function disconnection(tab_id) {
        for (let key in wss) {
            if (key === tab_id) {
                console.log('disconnect for key : ', key)
                wss[key].close();
                delete wss[key];
            }
        }
        // if (ws) {
        //     ws.close();
        // }
    }

    async function setBaseOriginForImage() {
        const baseOr = await BASE_ORIGIN;
        setBaseOrigin(baseOr)
    }
}
